module.exports = __webpack_public_path__ + "img/visa.b39b39d.png";